exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product-detail-multi-tickets-book .product-detail-multi-tickets-book-title{line-height:1em}", ""]);

// exports
